import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PackageModel } from '@/models'

interface CheckDuplicatePackageRequest {
  buildingId: number
  trackingNumber: string
}

interface CheckDuplicatePackageResponse {
  packages: PackageModel[]
  count: number
}

export const checkDuplicatePackage = async (data: CheckDuplicatePackageRequest) => {
  const response = await authAPI.get<CheckDuplicatePackageResponse>(`/packages`, {
    params: data,
  })
  return response.data
}

export const useCheckDuplicatePackage = () => {
  return useMutation({
    mutationFn: checkDuplicatePackage,
  })
}
